import React from "react";

function Support() {
  const supportStyle = {
    padding: "0.75em",
    background: "rgba(0, 0, 0, 0.1)"
  }; 
  
  return (
    <div className={"ui-font-bold-1"} style={supportStyle}>
      <a href="https://www.canotis.de" target="_blank" rel="noopener noreferrer">Canotis AG &copy;</a>
    </div>
  );
}
export default (Support);
